import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Shield } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
        <Shield className="h-10 w-10 text-primary animate-pulse" />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
          System wird geladen…
        </p>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
